<template>
    <!--begin::Authentication - Password reset -->
    <div class="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
        <!--begin::Content-->
        <div class="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
            <!--begin::Logo-->
            <a href="#" class="mb-5">
                <img
                    alt="Logo"
                    :src="'/admin/images/logo_mostra.png'"
                    class="h-100px"
                />
            </a>
            <!--end::Logo-->
            <!--begin::Wrapper-->
            <div class="w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
                <!--begin::Form-->
                <form
                    @submit.prevent="form.post(this.route('password.email'))"
                    class="form w-100"
                    novalidate="novalidate"
                    id="kt_password_reset_form"
                >
                    <!--begin::Heading-->
                    <div class="text-center mb-10">
                        <!--begin::Title-->
                        <h1 class="text-dark mb-3">Esqueceu a senha?</h1>
                        <!--end::Title-->
                        <!--begin::Link-->
                        <div class="text-gray-400 fw-bold fs-4">
                            Informe o seu e-mail para resetar sua senha
                        </div>
                        <!--end::Link-->
                    </div>
                    <!--begin::Heading-->
                    <!--begin::Input group-->
                    <div class="fv-row mb-10">
                        <label class="form-label fw-bolder text-gray-900 fs-6">E-mail</label>
                        <input
                            v-model="form.email"
                            class="form-control form-control-lg form-control-solid"
                            :class="{'is-invalid': form.errors.email}"
                            type="text"
                            autocomplete="off"
                            placeholder="exemplo@dominio.com"
                            @blur="form.clearErrors('email')"
                        />
                        <message-validation v-if="form.errors.email" :message="form.errors.email"/>
                    </div>
                    <!--end::Input group-->
                    <!--begin::Actions-->
                    <div class="d-flex flex-wrap justify-content-center pb-lg-0">
                        <button
                            type="submit"
                            id="kt_sign_up_submit"
                            class="btn btn-lg btn-primary me-2"
                            :class="{disabled: form.processing}"
                            :disabled="form.processing"
                            :data-kt-indicator='form.processing ? "on" : "off"'
                        >
                            <span class="indicator-label">Resetar senha</span>
                            <span class="indicator-progress">Aguarde...
									<span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                        </button>
                        <Link
                            :href="this.route('login')"
                            class="btn btn-lg btn-light-primary fw-bolder"
                        >
                            Voltar para o Login
                        </Link>
                    </div>
                    <!--end::Actions-->
                </form>
                <!--end::Form-->
            </div>
            <!--end::Wrapper-->
        </div>
        <!--end::Content-->
        <footer-auth />
    </div>
    <!--end::Authentication - Password reset-->
</template>

<script>
import { useForm, Link } from '@inertiajs/inertia-vue3'
import MessageValidation from "@forms/MessageValidation";
import FooterAuth from "./FooterAuth";
export default {
    components: {
        FooterAuth,
        Link,
        MessageValidation
    },

    setup() {
        const form = useForm({
            email: null,
        });

        return { form };
    }
}
</script>
